import ReactHtmlParser from 'react-html-parser';

export const parseMention = ({
  html,
  renderNode,
}) => {
  return ReactHtmlParser(html, {
    transform: (node) => {
      // Look for and replace mention span with proper component
      const isMention = node.type === 'tag' && node.name === 'span'
        && node.attribs && node.attribs['data-id']
        && node.attribs['data-id'].substr(0, 9) === 'comments-';
      if (isMention) { // Found a mention
        const isMentionUser = node.attribs['data-id'].substr(9, 5) === 'user-';
        if (isMentionUser) { // Found a user mention
          const userId = node.attribs['data-id'].substr(14);
          return renderNode(userId);
        }
      }
      return undefined; // node is rendered, as is, if we return undefined
    },
  });
};
